import type { FileType, FileUploadData } from "~~/types/file";

type UploadArgs = {
  file: File;
  type: FileType;
  organization?: string;
  formId?: number;
  submissionId?: number;
  questionId?: number;
};

export const useUploadFile = () => {
  const { t } = useI18n();
  const toast = useToast();
  const { mainBaseURL } = useRuntimeConfig().public;

  const { biPart } = apiRepository(mainBaseURL);
  const { organization: orgUrl } = useRoute().params;

  async function uploadSmallFile(args: UploadArgs) {
    const body = new FormData();
    body.append("file", args.file);
    const { success, data, status } = await biPart<FileUploadData>(
      `/upload/small/${args.type}?path=${args.organization ?? orgUrl}&path=${args.formId}&submissionId=${args.submissionId}&questionId=${args.questionId}`,
      body,
      {
        requiresAuthorization: true,
      },
    );

    if (!success) {
      toast.add({
        title: t("toast.title.error"),
        description: t("toast.description.file-upload-failed"),
        color: "error",
      });
    }
    return { data, success, status };
  }

  return { uploadSmallFile };
};
